import styled from 'styled-components';

import { inputStyle } from '../Input/Input.styles';

export const Textarea = styled.textarea`
  ${inputStyle}
  height: auto;
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]};
`;
